var r={};export{r as __exports};
//# sourceMappingURL=createWebStorage.js.map
